module.exports = "<app-type-warranty *ngFor=\"let repair of repairWarranties\" [repairWarranty]=\"repair\"></app-type-warranty>\r\n"